import { ChangeDetectionStrategy, Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'preferences-2',
  templateUrl: './preference_2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryPreference2Component implements OnInit, OnDestroy {
  @Input() data;
  @Output() continuePreference2Emitter: EventEmitter<any> = new EventEmitter();
  username;
  subscription = new Subscription();

  constructor(private loginService: LoginStoreEffects, private cd: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.username = state.data.first_name;
        this.cd.detectChanges();
      })
    );
  }

  continue(next_step: string) {
    this.continuePreference2Emitter.emit({ status: next_step, id: this.data.id });
  }

  back() {
    this.continuePreference2Emitter.emit({ status: 'backward' });
  }
}
